<template>
    <div v-if="store.application_type != 'calendar' && store.application_type != 'calendar_single'">
        <template v-if="cStep != 1">
            <div style="color: red; font-weight: 700;" v-if="store.totalSizesQty[tabName] < store.inputProductData.minOrderQty">
                {{ store.inputProductData.minOrderQty - store.totalSizesQty[tabName] }} more items until minimum quantity
            </div>
            <div :class="[customColor]" style="font-weight: 700;" v-if="store.totalSizesQty >= store.inputProductData.minOrderQty">Minimum quantity reached!</div>
        </template>

        <div>
            Minimum Order Quantity of {{ store.inputProductData.minOrderQty }} | Mix-n-Match in Increments of {{ store.inputProductData.qtyIncrement }}
        </div>
    </div>
</template>

<script>
import { store } from './store';

export default {
    props: {
        cStep: Number,
        tabName: String
    },
    data() {
        return {
            store: store
        }
    },
    methods: {
        back() {
            this.$emit("backToParent");
        }
    },
    created() {
        console.error("++++++++++++++Requirenment component created+++++++++++++++++++++");
        console.log(this.store);
        console.log(this.store.application_type);
    },
    mounted(){
        console.error("++++++++++++++Requirenment component Mounted+++++++++++++++++++++");
        console.log(this.store);
        console.log(this.store.application_type);
    },
    computed: {
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
    },
}

</script>

<style>

</style>